// extracted by mini-css-extract-plugin
export default {"input":"SearchInput__input--1vI1r","searchIcon":"SearchInput__searchIcon--qeL3U"};